export default "__VITE_ASSET__B$Mf4VNX__"